import React, { useEffect, useState } from "react";
import { Box, MainHolder, StyledText } from "../../../../components/common";
import styled from "styled-components";
import { NewBackButton, NoticeIcon } from "../../../../components/svgs";
// import useTimer from "../../../../hooks/useTimer";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useTheme } from "../../../../hooks";
// import useCountDown from "../hooks/timer";

import { VotingStatusCard } from "../components";
import { BusinessChallengeService } from "../../../../services";

const PollPage = () => {
  const [contestants, setContestants] = useState([]);
  const [loadingContestants, setLoadingContestants] = useState(false);

  const { themeContext, theme } = useTheme();
  const history = useHistory();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  const isCompleted = false;

  const totalVotes = contestants
    .map((contestant) => contestant.votes)
    .reduce((acc, votes) => acc + votes, 0);
  const token = JSON.parse(localStorage.getItem("token"));

  const getContestants = () => {
    setLoadingContestants(true);
    BusinessChallengeService.getContestants(token)
      .then(data => {
        const { data: contestantsData } = data;
        if (contestantsData) setContestants(contestantsData)
      })
      .catch(e => console.log(e))
      .finally(() => setLoadingContestants(false))
  };

  useEffect(() => {
    getContestants();
  }, []);

  return (
    <>
      <MainHolder
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
        }}
      >
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: isCompleted ? "white" : "#EE2737",
            paddingLeft: 15,
            paddingTop: 5,
            paddingBottom: 5,
          }}
        >
          <div style={{ position: "absolute" }}>
            <BackButtonContainer
              onClick={() => {
                history.push(`/home?token=${token}&tabid=4`);
              }}
            >
              <NewBackButton />
            </BackButtonContainer>
          </div>
          <Box
            style={{
              display: "flex",
              flex: 1,
              backgroundColor: isCompleted ? "white" : "#EE2737",
              justifyContent: "center",
            }}
          >
            <StyledText style={{ fontSize: 18, color: "white" }}>
              {/* {isCompleted
                ? "Voting Poll"
                : `Voting ends in ${days}d:${minutes}hrs:${seconds}s`} */}
            </StyledText>
          </Box>
        </Box>
        <div
          style={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            alignSelf: "center",
          }}
        >
          {!isCompleted && (
            <>
              <StyledText>Voting Poll</StyledText>
              <StyledText
                style={{
                  textAlign: "center",
                  fontFamily: "MTNRegular",
                  fontSize: 12,
                }}
              >
                The existing poll reflects user votes exclusively and doesn't encompass the votes from judges, which constitute a percentage of the overall poll.
              </StyledText>
            </>
          )}
          <HorizontalSeparator />
          <StyledText style={{ marginRight: isCompleted ? "50%" : "60%" }}>
            {isCompleted ? "How viewers voted" : "Ongoing Votes"}
          </StyledText>
          <div
            style={{
              flexDirection: "column",
              justifyContent: "center",
              display: "flex",
              border: "1px solid black",
              borderColor: background,
              borderRadius: 10,
              padding: 5,
            }}
          >
            <StyledText
              style={{
                fontSize: 24,
                margin: 0,
                color: background,
              }}
            >
              {totalVotes}
            </StyledText>
            <StyledText
              style={{
                fontFamily: "MTNRegular",
                fontSize: 10,
                margin: 0,
              }}
            >
              Votes in
            </StyledText>
          </div>

          <CountedVoteInfoContaier>
            <NoticeIcon width={15} fill="#7F7F7F" style={{ marginRight: 5 }} />
            <StyledText
              style={{
                fontFamily: "MTNRegularItalic",
                fontSize: 10,
                color: "#7F7F7F",
              }}
            >
              Your one-time vote is counted. Stay tuned for the results!
            </StyledText>
          </CountedVoteInfoContaier>
          {contestants.map((contestant) => (
            <VotingStatusCard
              imgUrl={contestant.imageUrl}
              teamName={contestant.name}
              numberOfVotes={contestant.votes}
              width={Math.floor((contestant.votes / totalVotes) * 100)}
              votePercent={Math.floor((contestant.votes / totalVotes) * 100)}
            />
          ))}
        </div>
      </MainHolder>
    </>
  );
};

export default PollPage;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CountedVoteInfoContaier = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
`;

const HorizontalSeparator = styled.div`
  width: 100%;
  height: 0.3px;
  background-color: #7f7f7f;
  margin-top: 10;
`;
